const AppID = {
  Awin: 'track-awin',
  Facebook: 'track-facebook',
  Tiktok: 'track-tiktok',
} as const

export const buildAwinCustomData = (awc: string | null) => {
  return {
    customData: { ...(awc && { awc }), sourceIsAwin: 'true' as const },
    appId: AppID.Awin,
  }
}

export const buildFacebookCustomData = ({
  fbc,
  fbp,
}: {
  fbc: string | null
  fbp: string | null
}) => {
  return {
    customData: { ...(fbc && { fbc }), ...(fbp && { fbp }) },
    appId: AppID.Facebook,
  }
}

export const buildTiktokCustomData = ({ ttp }: { ttp: string | null }) => {
  return {
    customData: { ...(ttp && { ttp }) },
    appId: AppID.Tiktok,
  }
}
